module.exports = __webpack_public_path__ + "static/img/video_icon3_2.e90c71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon3_2.png
// module id = bHhn
// module chunks = 0